import Entity from '../entity';
import Airport from './airport';
import Aircraft from './aircraft';
import AirlineCompany from './airlineCompany';
import FlightProvider from './flightProvider';
import FlightPrice from './flightPrice';
export default class FlightChangeGeneral extends Entity<string> {
  fromAirportId: string;
  fromAirport: Airport;
  fromAirportName: string;
  toAirportId: string;
  toAirport: Airport;
  toAirportName: string;
  departureDate: string;
  arrivalDate: string;
  originalDepartureDate: string;
  originalArrivalDate: string;
  departureTerminalId: any;
  departureTerminal: any;
  arrivalTerminalId: any;
  arrivalTerminal: any;
  flightDuration: string;
  totalDuration: string;
  code: string;
  iataCode: string;
  departureHour: string;
  arrivalHour: string;
  flightHours: string;
  airlineName: string;
  flightNo: string;
  airCraftId: string;
  airCraft: Aircraft;
  airCraftFullName: any;
  airLineCompanyId: string;
  airlineCompany: AirlineCompany;
  airlineLogoUrl: any;
  packageProviderId: string;
  packageProvider: FlightProvider;
  hasStops: boolean;
  stopCount: number;
  flightIsActive: boolean;
  isActive: boolean;
  dynamicId: boolean;
  minPrice: number;
  currencyId: string;
  currency: any;
  baggageLimit: number;
  numberOfSeats: number;
  changeCount: number;
  passengerCount: number;
  totalQuota: number;
  totalConfirmed: number;
  route: string;
  flightPrices: FlightPrice[];
  flightPriceRules: any[];
  flightUrl: any;
  priceGenerals: any[];
  isCampaign: boolean;
  pnr: string;
  flight: any;
  handBaggageLimit: number;
  isPropertyAnyChange: boolean;
}
